import {
  PopUpModalContainer,
  PopUpModalText,
  PopUpModalText2,
  PopUpModalTitle,
  PopUpModalButton,
  ModalMask,
} from "./style";

const NoCoreProModal = (props) => {
  return (
    <>
      {props.display && (
        <ModalMask style={{ backgroundColor: "#333333" }} open={true}>
          <PopUpModalContainer>
            <PopUpModalTitle>{props.title}</PopUpModalTitle>
            <PopUpModalText>{props.text}</PopUpModalText>
            <PopUpModalText2>{props.text2}</PopUpModalText2>
            <PopUpModalButton
              disabled={false}
              onClick={props.onClick}
              marginTop={"30px"}
              marginBottom={"0px"}
            >
              {props.buttonText}
            </PopUpModalButton>
          </PopUpModalContainer>
        </ModalMask>
      )}
    </>
  );
};

export default NoCoreProModal;
